(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counters"] && !Shopify.designMode) return;
  try {
    
  class StatsCountersAutoOverlap extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.overlapAuto) return;
      if (this.dataset.observing) return;
      this.dataset.observing = 'true';

      const applyOverlap = () => {
        const h = this.offsetHeight;
        const wrapper = this.closest('.shopify-section');
        if (!wrapper) return;
        wrapper.style.marginTop = `-${h}px`;
      };

      applyOverlap();

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(applyOverlap);
        ro.observe(this);
      } else {
        window.addEventListener('resize', applyOverlap);
      }
    }
  }

  if (!customElements.get('stats-counters')) {
    customElements.define('stats-counters', StatsCountersAutoOverlap);
  }

  } catch(e) { console.error(e); }
})();
})();
